import {CustomsRequirement} from "./queries"


export function humanizeCustomsRequirementScreenType(screeningType: CustomsRequirement["screeningType"]) {
    switch (screeningType) {
        case "Взвешивание":
            return "Взвешивание";
        case "МИДК":
            return "МИДК";
        case "Физический":
            return "Физдосмотр";
        default:
            return `${screeningType}*`;
    }
}